module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1173.6db03550.png";